<template>
  <div class="IberoMenu">
    <b-navbar toggleable="lg" class="navbar navbar-expand-lg">
      <b-navbar-toggle
        target="nav-collapse"
        class="navbar-toggler float-xs-right"
      ></b-navbar-toggle>
      <b-collapse id="nav-collapse" class="justify-content-end" is-nav>
        <b-navbar-nav>          
          <b-nav-item-dropdown v-if="this.$session.get('IberoJWT')" class="menuNavItem" text="Servicios" right>
            <b-dropdown-item v-on:click="getPage('formulario-inscripcion/PortalWeb')">Formulario de Inscipción</b-dropdown-item>
            <b-dropdown-item v-if="this.$session.get('IberoJWT')" v-on:click="getPage('Voting')">Votaciones Ibero</b-dropdown-item>
          </b-nav-item-dropdown>          
          
          <b-nav-item class="menuNavItem" :href="this.$store.state.linksRedirect.PTEmple">PORTAL ESTUDIANTES</b-nav-item>

          <b-nav-item-dropdown v-if="this.$session.get('IberoJWT')" class="menuNavItem" :text="this.$session.get('IberoJWT').given_name" right>
            <b-dropdown-item v-on:click="getPage('Account')">{{$ml.get('Account')}}</b-dropdown-item>
            <b-dropdown-item v-on:click="getPage('LogOut')">{{$ml.get('Exit')}}</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import authentication from '@/store/authentication'

export default {
  name: "UserMenu",
  methods: {
    getPage(refPage) {
      if(refPage === 'LogOut'){
        this.$session.destroy();
        this.$store.state.configAuth.redirectUri = this.$store.state.configAuth.redirectUriLogout;
        authentication.initialize(this.$store.state.configAuth).then(_ => { }).catch( e => console.log(e));
        authentication.signOut();
        refPage = '';
      }
      this.$router.push({ path: "/" + refPage }).catch(err => { 
        if(this.$router.currentRoute.path.replace("/", "") === refPage.replace("/", "")){
          window.location.assign(refPage);
        }
      });
    }
  }
};
</script>

<style>
.IberoMenu {
  margin-top: 3px;
}
.menuNavItem {
  color: #000;
  padding-left: 20px;
  padding-right: 20px;
  font-size: 20px !important;
  text-transform: uppercase;
  font-size: 10px;
  margin-top: 5px;
  margin-bottom: 10px;
}


.navbar-light .navbar-nav .nav-link:hover,
.navbar-light .navbar-nav .nav-link:focus {
  color: #000;
  text-transform: uppercase;
}
.menuNavItem:hover {
  color: #000;
  font-weight: bold;
  text-decoration: underline;
}
.navbar-light .navbar-nav .nav-item .nav-link {
  color: #000;
}
.dropdown-item {
  text-transform: capitalize !important;
  color: #656565 !important;
  font-size: 14px !important;
  background-color: #fff;
  border-bottom: 2px solid #f3f3f3 !important;
}

.dropdown-menu li:last-child .dropdown-item {
  border-bottom: none !important;
}

.dropdown-item:hover {
  color: #ffffff !important;
  background-color: #f2a900 !important;
}

@media (max-width: 991px) {
  .bright-pre-header {
    display: none;
  }
}
</style>

<style scoped>
.bg-light {
  background-color: #f3f3f3 !important;
}
</style>